/**
 * Mentor Consultation — English (nested for t('chat.…'))
 */
export default {
	meta: {
		title: "Mentor Consultation - SeerQ",
		keywords: "mentor consultation,online consultation,fortune consultation",
		description:
			"One-on-one online consultation with certified mentors for professional guidance on life and fortune.",
	},
	breadcrumb: {
		home: "Home",
		current: "Mentor Consultation",
	},
	chatList: {
		title: "Chat List",
		searchPlaceholder: "Search mentor name",
		inService: "In session...",
		empty: "No matching results",
	},
	chatRoom: {
		viewHome: "View Profile",
		serviceOrder: "Order Service",
		saySomething: "Say something",
		highServiceCountdown: "Reminder: Your consultation service countdown",
		continueConsult: "Continue Consultation",
		freeChatCountdown: "Reminder: 15-minute unlimited Q&A service countdown",
		sendRecommend: "Send",
		sendAria: "Send",
		loading: "Loading...",
		noMessages: "No chat history",
		loadMore: "Click or pull to load more",
		noMoreData: "No more messages",
		serviceEndsAt: "Service ends {date}",
		pleaseInput: "Type a message",
		pleaseInputFollowUp: "Enter your follow-up in one message",
		freeChatUsedUp: "Today's free chat limit reached",
		freeChatRemaining: "{count} free messages left today",
		quote: "Quote",
		recall: "Recall",
		quoteImage: "[Image]",
		quoteAudio: "[Audio]",
		emptyMessageError: "Cannot send an empty message",
	},
	service: {
		consultService: "Consultation",
		fahuiService: "Ritual Service",
		noData: "No data",
		originalPrice: "Original {price} points",
		finalPriceLabel: "Final price",
		orderNow: "Order Now",
	},
	recommendTeachers: {
		ariaLabel: "Recommended Mentors",
		title: "Recommended Mentors",
		loading: "Loading...",
		empty: "No recommended mentors",
		prevNav: "Previous mentors",
		nextNav: "Next mentors",
		avatarAlt: "Mentor avatar",
		defaultName: "Mentor",
		defaultSummary: "All-round mentor, 99% user satisfaction",
		defaultTags: ["Love & Relationships", "Marriage Recovery"],
		viewDetail: "View Details",
		consultNow: "Consult Now",
	},
	message: {
		notSupport: "This message is not supported on web. Please view in the App.",
		goToApp: "Please view in the App",
		downloadAppForMore: "Download the App to see more",
		goToAppOperate: "Please use the App for this action",
		recommendServiceTitle: "Your mentor recommends a service",
		originalPrice: "Original {price} coins",
		orderNow: "Order Now",
		serviceOrder: "Order Service",
		inviteReward: "Your mentor invites you to tip",
		rewardNow: "Tip Now",
		payOrder: "Payment",
		rewardTeacher: "Tip Mentor",
		rewardDesc: "Thank you for your support. You may tip as a token of appreciation.",
		actualPayment: "Amount due:",
		insufficientPoints: "Insufficient balance",
		paying: "Processing...",
		confirmPay: "Confirm Payment",
		generatingOrder: "Creating order...",
		tipTeacher: "Tip Mentor",
		remark: "Note: ",
		teacherCardDesc: "Mentor Card",
		yearsExperience: "{year} years experience",
		orderTime: "Order time: ",
		evaluated: "Reviewed",
		notEvaluated: "Not reviewed",
		coupon: "Coupon",
		discount: " off",
		couponGift: "{name} sent you a [{couponName}] coupon",
		noThresholdCoupon: "No minimum spend",
		minSpendCoupon: "Min. spend {amount}",
		usageRange: "Applicable to: ",
		validUntil: "Valid until: ",
		sending: "Sending",
		serviceCompleted: "{serviceName} service completed",
		normalQuestion: "Standard Question",
		premiumService: "Premium Service",
	},
};
